import {LinkButton} from '@primer/react'
import {CommentIcon} from '@primer/octicons-react'
import type {IssueCommentInfo} from '@github-ui/dotcom-schema/types/pull_requests/v1/timeline'
import {useLayoutRouteData} from '../../../../page-data/loaders/use-layout-route-data'
import {Link} from '@github-ui/react-router'
import {routeToIssueComment} from '../../../overview/data/use-comments-routing'

export function IssueCommentAction({info}: {info: IssueCommentInfo}) {
  const {pullRequest, repository} = useLayoutRouteData()
  const commentId = info.commentId

  if (!commentId) {
    return null
  }
  return (
    <LinkButton
      as={Link}
      to={routeToIssueComment(
        {
          owner: repository.ownerLogin,
          repo: repository.name,
          pr_number: pullRequest.number.toString(),
        },
        commentId.toString(),
      )}
      size="small"
      variant="invisible"
      aria-label="View issue comment"
      icon={CommentIcon}
      className="flex-items-center"
    />
  )
}
